import { useEffect, useState } from "react"
import { FrameWrapper, Frame, SignImage, Caption } from "./ReadingSignsStyle"
import { ReadingSignsData } from "../../../../05_reading/03_signs/ReadingSignsData"
import { useSelector } from "react-redux"

const Signs = () => {

    const currentLesson = useSelector(state => state.lesson.currentLesson)

    const [signData, setSignData] = useState(
        ReadingSignsData.filter(val => val.lesson === currentLesson)
    )

    const showCaption = (valueId) => {
        setSignData(prev => 
            prev.map((value, index) =>
                value.id === valueId ? 
        {
            ...value,
            visibility: value.visibility === "hidden" ? "visible" : "hidden"
        } : value
            )
        )
    }

    useEffect(() => {
        setSignData(ReadingSignsData.filter(val => val.lesson === currentLesson))
    }, [currentLesson])

  return (
    <FrameWrapper>
        {signData.map((value, index) => (
            <Frame key ={index}>
                <SignImage
                src={value.image}
                id={value.id}
                onClick={() => showCaption(value.id)}
                />
                <Caption style={{visibility: value.visibility}}>{value.caption}</Caption>
            </Frame>
        ))}
    </FrameWrapper>
  )
}

export default Signs
